import "../../styles/CaesarСipherTextArea.css";
import { useGame } from "../../GameContext";



const TextArea = () => {
  const { guessedWords } = useGame();

  return (
    <div
      className="CaesarСipher-Area"
    >
      <div className="CaesarСipher-subtitle">
        Найденные слова
      </div>

      <div className="CaesarСipher-textArea">
        {guessedWords.map((word, index) => (
          <div key={index}>{word}</div>
        ))}
      </div>
    </div>
  );
};
export default TextArea;
